import usePulseScope from '@/shared/components/PulseScope/usePulseScope'
import { birthdateInputOverrides } from './styled-components'

const useBirthdate = () => {
  const isPulse = usePulseScope()

  return { inputOverrides: isPulse ? undefined : birthdateInputOverrides }
}

export default useBirthdate
